import { IBulkEnquiryProduct } from "Interfaces/interface.enquirypayload";
import { IAttributeImage, IProduct } from "Interfaces/interface.productsapi";
import { ICartItem } from "store/types/cartTypes";

export const filterImageByAttributes = (
  product: IProduct | ICartItem | IBulkEnquiryProduct,
  selectedAttributes: any,
  defaultImage?: string
): IAttributeImage | undefined => {
  if (!product?.images || !Array.isArray(product.images)) return undefined;
  if (!selectedAttributes || typeof selectedAttributes !== "object")
    return undefined;

  const exactMatch = product.images.find((image) => {
    if (typeof image === 'string') return false;

    const attributeValues = image?.attributeValues || {};

    const normalizedAttributeValues = Object.keys(attributeValues).reduce(
      (acc, key) => {
        acc[key.toLowerCase()] = attributeValues[key];
        return acc;
      },
      {} as Record<string, any>
    );

    const availableAttributes = Object.entries(selectedAttributes).filter(
      ([key]) => normalizedAttributeValues.hasOwnProperty(key.toLowerCase())
    );

    if (availableAttributes.length === 0) return false;

    return availableAttributes.every(([key, selectedValue]) => {
      const imageValue = normalizedAttributeValues[key.toLowerCase()];

      if (typeof selectedValue === "string" && typeof imageValue === "string") {
        return (
          selectedValue.trim().toLowerCase() === imageValue.trim().toLowerCase()
        );
      }

      return false;
    });
  });

  if (exactMatch && typeof exactMatch !== 'string') {
    return exactMatch;
  }

  const imageWithNullAttributes = product.images.find((image) => {
    if (typeof image === 'string') return false;
    return (
      !image?.attributeValues || Object.keys(image.attributeValues).length === 0
    );
  });

  if (imageWithNullAttributes && typeof imageWithNullAttributes !== 'string') {
    return {
      ...imageWithNullAttributes,
      images:
        imageWithNullAttributes.images &&
          imageWithNullAttributes.images.length > 0
          ? imageWithNullAttributes.images
          : defaultImage
            ? [defaultImage]
            : [],
    };
  }

  return undefined;
};

export const getProductNameWithAttributes = (
  product: IProduct | ICartItem | IBulkEnquiryProduct
) => {
  const attributes = product?.variants?.[0]?.attributes || {};

  const values = Object.values(attributes)
    .filter((val) => typeof val === "string" && val.trim() !== "")
    .map((val) => val.trim());

  if (values.length === 0) return null;

  return <span className="text-gray-500 text-xs">({values.join(", ")})</span>;
};

export const getProductAttributeString = (
  product: IProduct | ICartItem | IBulkEnquiryProduct
): string => {
  const attributes = product?.variants?.[0]?.attributes || {};

  const values = Object.values(attributes)
    .filter((val) => typeof val === "string" && val.trim() !== "")
    .map((val) => val.trim());

  return values.length > 0 ? `(${values.join(", ")})` : "";
};

